import { upsellRecommendations, formatMoney, type UpsellRecommendation } from "@/mocks/managerWorkspace";

export default function UpsellWidget() {
  const visibleRecs = upsellRecommendations.slice(0, 3);
  const totalPotential = upsellRecommendations.reduce((sum, r) => sum + r.potentialAmount, 0);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-1.5 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-stack-line text-[12px] text-[#2D6A4F]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Допродажи / Повторные продажи — ткани</span>
        </div>
      </div>
      <div className="px-3 py-1 bg-[#D4EDDA]/40 border-b border-[#D5CA8A]/50">
        <span className="text-[9px] text-[#666666] mr-1">Потенциал:</span>
        <span className="text-[10px] font-bold text-[#2D6A4F]">{formatMoney(totalPotential)}</span>
      </div>
      <div className="flex-1 overflow-auto p-2 space-y-1">
        {visibleRecs.map((r: UpsellRecommendation, i: number) => (
          <div key={i} className="p-1.5 rounded border border-[#D5CA8A]/40 hover:bg-[#FDF2B5]/20 transition-colors">
            <div className="flex items-center justify-between mb-0.5">
              <span className="text-[11px] font-semibold text-[#2D2D2D]">{r.client}</span>
              <span className="text-[11px] font-bold text-[#2D6A4F]">{formatMoney(r.potentialAmount)}</span>
            </div>
            <div className="flex items-center gap-1 text-[10px] text-[#666666] mb-0.5">
              <span>{r.currentProduct}</span>
              <i className="ri-arrow-right-line text-[9px]"></i>
              <span className="font-medium text-[#2D2D2D]">{r.recommendedProduct}</span>
            </div>
            <p className="text-[10px] text-[#666666] leading-relaxed line-clamp-2">{r.reason}</p>
          </div>
        ))}
      </div>
      <div className="px-3 py-1 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все рекомендации
        </button>
      </div>
    </div>
  );
}